<template>
  <BaseDialog
    v-model="showDialog"
    :title="title"
    :dialogIcon="dialogIcon"
    btnActionName="Lagre"
    btnCloseName="Lukk"
    @action="close"
  >
    <template v-slot>
      <v-btn-toggle
        v-if="
          $vuetify.breakpoint.mobile &&
          (isTrysilhus || (!isTrysilhus && isMainContactPerson))
        "
        v-model="showAll.value"
        style="width: 50%"
        class="mb-4"
        mandatory
        color="primary"
        dense
      >
        <v-btn block depressed :value="false" @click="changeShowAll(false)">
          Vis mine
        </v-btn>

        <v-btn block depressed :value="true" @click="changeShowAll(true)">
          Vis alle
        </v-btn>
      </v-btn-toggle>

      <slot :items="items" :headers="headersData">
        <div v-for="(head, index) in headersData" :key="index">
          <slot :name="'filter'" :items="items" :head="head">
            <slot
              :name="'filter.' + head.value"
              :items="items"
              :head="head"
              :headers="headersData"
            >
              <BaseTableSearchField
                class="mb-4"
                v-if="head && !head.removeFilter"
                v-model="head.filterValues"
                :filterClause.sync="head.filterClause"
                :type="head.type"
                :items="items"
                :selectData="head.value"
                :headers="headersData"
                :lable="head.text"
                filled
                :dense="false"
                :outlined="false"
                :clearable="clearable"
              />
            </slot>
          </slot>
        </div>
      </slot>
    </template>
  </BaseDialog>
</template>

<script lang="ts">
import Vue from "vue";
import { mapGetters } from "vuex";

import BaseDialog from "@/components/shared/dialog/BaseFilterDialog.vue";
import BaseTableSearchField from "@/components/shared/table/BaseTableSearchField.vue";

export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    headers: {
      type: Array,
    },
    items: {
      type: Array,
    },
    title: {
      type: String,
      default: "Filter",
    },
    dialogIcon: {
      type: String,
      default: "mdi-filter-variant",
    },
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    async changeShowAll(value: boolean) {
      this.$emit("changeShowAll", value);
    },
    close() {
      this.showDialog = false;
    },
  },
  computed: {
    ...mapGetters({
      isTrysilhus: "shared/isTrysilhus",
      isMainContactPerson: "shared/isMainContactPerson",
      showAll: "tables/showAll",
    }),
    showDialog: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean) {
        this.$emit("input", value);
      },
    },
    headersData: {
      get(): Array<any> {
        return this.headers;
      },
    },
  },
  components: {
    BaseDialog,
    BaseTableSearchField,
  },
});
</script>
